// extracted by mini-css-extract-plugin
export default {"scrollBar":"ModalRightDialog_scrollBar__Drt2G"};